import type { Transaction } from "@rocicorp/zero";
import { nanoid } from "nanoid";
import * as z from "zod";
import type { UserAction } from "../aiSdkMessages";
import { zql } from "../generatedDrizzleSchema";

export { makeBranchParams } from "../copyOnWrite";

export const generateId = () => nanoid(12);

export const branchSchema = z.object({
  branchId: z.string(),
  forkBranchId: z.string(),
  forkCommitId: z.string(),
  forkChatId: z.string(),
  workingCommitId: z.string(),
  workingChatId: z.string(),
});

export const stringRecord = z.record(z.string(), z.string());

export async function insertUserAction(
  tx: Transaction,
  commitId: string,
  userId: string,
  tenantId: string,
  actionType: UserAction["actionType"],
  metadata: UserAction["metadata"]
) {
  const [chat] = await tx.run(zql.chats.where("commitId", commitId));
  if (!chat) return;

  const lastEntries = await tx.run(
    zql.chatEntries
      .where("chatId", chat.id)
      .orderBy("createdAt", "desc")
      .limit(1)
  );

  const entryId = generateId();
  const now = Date.now();

  await tx.mutate.chatEntries.insert({
    id: entryId,
    chatId: chat.id,
    entryType: "UserAction",
    createdAt: now,
    previousEntryId: lastEntries[0]?.id ?? null,
    tenantId,
  });

  await tx.mutate.userActions.insert({
    entryId,
    userId,
    actionType,
    metadata,
    tenantId,
  });
}
